var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 6.75C7.25 4.13 9.38 2 12 2C14.62 2 16.75 4.13 16.75 6.75C16.74 9.32 14.73 11.4 12.17 11.49H12.15H12.1C12.04 11.48 11.96 11.48 11.88 11.49C9.26 11.4 7.25 9.32 7.25 6.75ZM6.93094 14.1499C9.74094 12.2899 14.2909 12.2899 17.0809 14.1499C18.3409 14.9899 19.0309 16.1299 19.0409 17.3599C19.0409 18.5999 18.3409 19.7399 17.0809 20.5899C15.6809 21.5299 13.8409 21.9999 12.0009 21.9999C10.1609 21.9999 8.32094 21.5299 6.92094 20.5899C5.66094 19.7499 4.96094 18.6099 4.96094 17.3799C4.96094 16.1499 5.66094 14.9999 6.93094 14.1499Z",
    fill: "url(#paint0_linear_5004_3689)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5004_3689",
    x1: 9.69164,
    y1: -2.78785,
    x2: 24.9426,
    y2: 5.30881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09EF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16E2EF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileActive);
export default __webpack_public_path__ + "static/media/profile-active.989af3dad49c660376405315a8d2538c.svg";
export { ForwardRef as ReactComponent };